import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CalendarCheckIcon, ClockIcon, MonitorIcon } from 'lucide-react';
interface BridgeScreenProps {
  onRestart: () => void;
}
const EASE = [0.23, 1, 0.32, 1] as const;
const DETAILS = [{
  icon: ClockIcon,
  label: '20 minutes'
}, {
  icon: MonitorIcon,
  label: 'Your own scans'
}, {
  icon: CalendarCheckIcon,
  label: 'A time that suits you'
}];
export function BridgeScreen({
  onRestart
}: BridgeScreenProps) {
  return <div className="flex flex-1 flex-col justify-center" data-id="element-190" data-mp="2ystdewrpuycu">
      <motion.p initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.24,
      ease: EASE
    }} className="text-[9.5px] uppercase tracking-micro text-blue" data-id="element-191" data-mp="2yue6sj2aob94">
        Curious about your own scans?
      </motion.p>

      <motion.h2 initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.28,
      delay: 0.06,
      ease: EASE
    }} className="mt-3 font-display text-[30px] font-semibold leading-[1.04] tracking-tight text-navy" data-id="element-192" data-mp="i47aww9uqqgm">
        Let’s look at a few
        <br data-id="element-193" data-mp="1u0ihnm74fgzy" />
        together.
      </motion.h2>

      <motion.p initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.26,
      delay: 0.14,
      ease: EASE
    }} className="mt-4 text-[13px] leading-relaxed text-mut" data-id="element-194" data-mp="1tzphj42o3pqs">
        A relaxed 20-minute walkthrough of OCT-based phenotyping — bring your own scans, and we’ll
        go through the biomarker patterns at your own pace.
      </motion.p>

      <ul className="mt-5 flex flex-col gap-2" data-id="element-195" data-mp="1b4sa7jgf5seo">
        {DETAILS.map((d, i) => <motion.li key={d.label} initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.24,
        delay: 0.2 + i * 0.06,
        ease: EASE
      }} className="flex items-center gap-3 rounded-xl border border-line bg-mist px-4 py-3" data-id="element-196" data-mp="1p3s1kyvbglej" data-mpi={i}>
            <d.icon className="h-4 w-4 shrink-0 text-blue" aria-hidden="true" data-id="element-197" data-mp="2wid7x1ip7kd2" />
            <span className="text-[13px] font-medium text-navy" data-id="element-198" data-mp="1t4v6vbpv2szx">{d.label}</span>
          </motion.li>)}
      </ul>

      <motion.div initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.26,
      delay: 0.42,
      ease: EASE
    }} className="mt-6 flex flex-col items-stretch gap-2" data-id="element-199" data-mp="1y60w2zkbby4p">
        <a href="#trailer" className="flex h-12 items-center justify-between gap-2 rounded-full bg-blue px-5 text-[13.5px] font-semibold text-paper transition-opacity duration-150 hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue focus-visible:ring-offset-2" data-id="element-200" data-mp="1af58kemw3p39">
          Book a phenotyping walkthrough
          <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-201" data-mp="1o7uyuv9gbg66" />
        </a>
        <button type="button" onClick={onRestart} className="mx-auto h-9 rounded-full px-4 text-[12px] text-mut transition-colors duration-150 hover:text-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-blue" data-id="element-202" data-mp="rm1eis5rfa84">
          Replay
        </button>
      </motion.div>
    </div>;
}